<template>
  <div
    class="auth-wrapper pr-15 pl-15"
    :style="{
      backgroundImage: 'url(' + $store.getters[`customization/loginBg`] + ')'
    }"
  >
    <div class="language">
      <LanguageBar />
    </div>
    <b-row class="register-form receive-notification-form">
      <b-col class="register-content-col">
        <img class="logo-image" :src="$store.getters[`customization/logo`]" />
        <div class="mode-selection mb-20">
          <div class="p-20">
            <!-- if not come from email, then don't load user's subscription status by default -->
            <ComplianceNotifications
              class="compliance-notifications"
              :emailInQuery="emailInQuery"
              :showUserEmailSubscriptionStatusByDefault="!!emailInQuery"
            />
            <div class="text-right" v-if="!emailInQuery">
              <el-button class="save-btn min-w-80" @click="next()">{{
                $t('text.next').toUpperCase()
              }}</el-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LanguageBar from '@/components/LanguageBar.vue'
import ComplianceNotifications from '@/components/register/ComplianceNotifications.vue'
import '@/assets/font/font.css'
import '@/assets/css/login.scss'
import '@/assets/css/global.scss'
export default {
  name: 'register',
  components: {
    LanguageBar,
    ComplianceNotifications
  },
  data() {
    return {
      emailInQuery: null
    }
  },
  mounted() {
    // come from email template
    if (this.$route.query && this.$route.query.email) {
      this.emailInQuery = this.$route.query.email
    }
  },
  methods: {
    next() {
      let invitationInfo = localStorage.getItem('invitationInfo')
      // if user in invitation process, after this, then go to verify invitation page
      if (invitationInfo) {
        invitationInfo = JSON.parse(invitationInfo)
        this.$router.push({
          path: '/verify-invitation',
          query: {
            completeSignIn: 1,
            region: invitationInfo.region
          }
        })
      } else {
        // if user in sign up process, then go to register page
        this.$router.push('/register')
      }
    }
  }
}
</script>
